// DOTA v1.0 Labels (15 classes)
export enum DotaV1Class {
    Plane = 0,
    Ship = 1,
    StorageTank = 2,
    BaseballDiamond = 3,
    TennisCourt = 4,
    BasketballCourt = 5,
    GroundTrackField = 6,
    Harbor = 7,
    Bridge = 8,
    LargeVehicle = 9,
    SmallVehicle = 10,
    Helicopter = 11,
    Roundabout = 12,
    SoccerBallField = 13,
    SwimmingPool = 14
}

// DOTA v2.0 Labels (18 classes) - extends v1.0 with additional classes
export enum DotaV2Class {
    Plane = 0,
    Ship = 1,
    StorageTank = 2,
    BaseballDiamond = 3,
    TennisCourt = 4,
    BasketballCourt = 5,
    GroundTrackField = 6,
    Harbor = 7,
    Bridge = 8,
    LargeVehicle = 9,
    SmallVehicle = 10,
    Helicopter = 11,
    Roundabout = 12,
    SoccerBallField = 13,
    SwimmingPool = 14,
    ContainerCrane = 15,
    Airport = 16,
    Helipad = 17
}

// DOTA v1.0 labels mapping
const dotaV1Lookup: Record<DotaV1Class, string> = {
    [DotaV1Class.Plane]: 'plane',
    [DotaV1Class.Ship]: 'ship',
    [DotaV1Class.StorageTank]: 'storage tank',
    [DotaV1Class.BaseballDiamond]: 'baseball diamond',
    [DotaV1Class.TennisCourt]: 'tennis court',
    [DotaV1Class.BasketballCourt]: 'basketball court',
    [DotaV1Class.GroundTrackField]: 'ground track field',
    [DotaV1Class.Harbor]: 'harbor',
    [DotaV1Class.Bridge]: 'bridge',
    [DotaV1Class.LargeVehicle]: 'large vehicle',
    [DotaV1Class.SmallVehicle]: 'small vehicle',
    [DotaV1Class.Helicopter]: 'helicopter',
    [DotaV1Class.Roundabout]: 'roundabout',
    [DotaV1Class.SoccerBallField]: 'soccer ball field',
    [DotaV1Class.SwimmingPool]: 'swimming pool'
};

// DOTA v2.0 labels mapping
const dotaV2Lookup: Record<DotaV2Class, string> = {
    [DotaV2Class.Plane]: 'plane',
    [DotaV2Class.Ship]: 'ship',
    [DotaV2Class.StorageTank]: 'storage tank',
    [DotaV2Class.BaseballDiamond]: 'baseball diamond',
    [DotaV2Class.TennisCourt]: 'tennis court',
    [DotaV2Class.BasketballCourt]: 'basketball court',
    [DotaV2Class.GroundTrackField]: 'ground track field',
    [DotaV2Class.Harbor]: 'harbor',
    [DotaV2Class.Bridge]: 'bridge',
    [DotaV2Class.LargeVehicle]: 'large vehicle',
    [DotaV2Class.SmallVehicle]: 'small vehicle',
    [DotaV2Class.Helicopter]: 'helicopter',
    [DotaV2Class.Roundabout]: 'roundabout',
    [DotaV2Class.SoccerBallField]: 'soccer ball field',
    [DotaV2Class.SwimmingPool]: 'swimming pool',
    [DotaV2Class.ContainerCrane]: 'container crane',
    [DotaV2Class.Airport]: 'airport',
    [DotaV2Class.Helipad]: 'helipad'
};

/**
 * Get the friendly string name for a DOTA v1.0 class
 */
export function showDotaV1ClassLabel( label: DotaV1Class ): string {
    return dotaV1Lookup[label];
}

/**
 * Get the friendly string name for a DOTA v2.0 class
 */
export function showDotaV2ClassLabel( label: DotaV2Class ): string {
    return dotaV2Lookup[label];
}

/**
 * Get the friendly string name for a YOLO 11 OBB class ID
 */
export function getYolo11ObbClassName( id: number, version: 'v1' | 'v2' = 'v1' ): string {
    if( version === 'v2' ) {
        return dotaV2Lookup[id as DotaV2Class] || 'unknown';
    }
    return dotaV1Lookup[id as DotaV1Class] || 'unknown';
}
